import versions from "data/versions.json"
export interface VersionedData {
  version: string
}

export interface Versions {
  itree: VersionedData
  geographies: Record<string, VersionedData>
}

export function getVersions(): Versions {
  return versions as Versions
}
